// Formateo de montos homologado para toda la app.
// No usamos toLocaleString() sin locale porque el separador de miles depende
// de la configuración regional del equipo (en algunos casos queda sin punto,
// con coma o con espacio). Acá el punto de miles siempre es el mismo.

export function formatNumber(value) {
    const n = Math.round(Number(value) || 0);
    const sign = n < 0 ? "-" : "";
    return sign + Math.abs(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function formatPrice(value) {
    const formatted = formatNumber(value);
    return formatted.startsWith("-") ? `-$${formatted.slice(1)}` : `$${formatted}`;
}
